import { useState } from "react";
import Button from "../Button";
import Chevron from "@/assets/icons/chevron.svg?react";
import { BrandChevron } from ".";
import { StepProps } from "@/data/onboarding/types";
import { useOnboarding } from "@/hooks/useOnboarding";
import { saveEmail } from "@/api";
import appConfig from "@/config/app-config";
import styles from "./Step.module.scss";
import { classnames } from "@/utils";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function EmailCollectionStep({ step, onAnswer }: StepProps) {
  const { answers } = useOnboarding();
  const [email, setEmail] = useState(
    typeof answers.emailCollection === "string" ? answers.emailCollection : "",
  );
  const [validationError, setValidationError] = useState<string>();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!EMAIL_REGEX.test(email)) {
      setValidationError("Ange en giltig e-postadress.");
      return;
    }

    if (appConfig.mailchimpListId) {
      saveEmail(email, appConfig.mailchimpListId).catch(console.error);
    }
    onAnswer(email);
  };

  const handleSkip = () => {
    onAnswer();
  };

  return (
    <>
      <ol className="checkmarks">
        <li>Varför det ofta är så svårt att gå ner i vikt?</li>
        <li>
          Vilka behandlingsalternativ som finns och hur läkemedel mot övervikt
          fungerar?
        </li>
        <li>Vilket stöd man kan få på sin viktresa?</li>
      </ol>
      <p>
        Få mer information via en kort mejlserie. Tre mejl, under tre dagar.
      </p>
      <form onSubmit={handleSubmit}>
        <div>
          <label>
            {step?.fieldLabel || "E-postadress"}
            <input
              type="email"
              inputMode="email"
              autoComplete="email"
              value={email}
              onChange={(e) => {
                if (validationError) {
                  setValidationError(undefined);
                }
                setEmail(e.target.value);
              }}
            />
          </label>
        </div>
        {validationError && (
          <div className={styles.validationError}>{validationError}</div>
        )}
        <div className={classnames([styles.disclaimer, styles.smallMargin])}>
          Genom att ange din e-postadress godkänner du att vi kontaktar dig med
          information kopplad till våra vårdtjänster. Läs mer i vår{" "}
          <a
            href="https://friska.se/integritetspolicy/"
            target="_blank"
          >
            integritetspolicy
          </a>
          .
        </div>
        <div className={styles.formAction}>
          <Button type="submit" iconRight={<Chevron />}>
            Nästa
          </Button>
        </div>
      </form>
      <div className={styles.formAction} style={{ marginTop: "7px" }}>
        <Button
          variant="secondary"
          onClick={handleSkip}
          iconRight={<BrandChevron />}
        >
          Hoppa över
        </Button>
      </div>
    </>
  );
}
